// extracted by mini-css-extract-plugin
export default {"cell":"styles_cell__c2Lhm","content":"styles_content__cjIqv","even":"styles_even__qZU08"};